module.exports = __webpack_public_path__ + "7fa736df96f8f41a54bf1309740133e5.png";